// Re-imagines pay under the Dentist/Oral Surgeon day filter, using the role-narrowed
// bCare/days-worked as if that was the provider's only data for the period.
//
// Ported (math only, no explainer/logging) from api/helpers/doctorPayHelper.js so the
// numbers can't drift from the real backend formulas. This is a FRONTEND PROTOTYPE per
// CDP-13105P — once stable, this should move to a real backend endpoint that recomputes
// pay server-side from the role-filtered day set (the source of truth for contract
// config/tier thresholds/ramp lives there, not in the report API response).
//
// Scope is intentionally limited to what the report API actually exposes to the frontend:
//   - Contract types: 'Greater Of', 'Greater Of w/HYN' (the daily-rate-vs-bCare "Category A"
//     comparison). GOX/GOZ need goxNonBillableCare narrowed per day (not done yet); Sum Of,
//     Collections(+Offset), GO GA, Prod Hurdle need ramp/hourly/collections inputs not
//     exposed per-practice to the frontend.
//   - Greater-Of category 'A' only. Category B/C need monthlyBasePay/monthlyBaseWorkDays,
//     which the report API doesn't return on the practice object.
//   - No tier bonus override — tier thresholds/records aren't exposed to the frontend either.
// Anything outside this scope returns null and the caller keeps the whole-period figure.

const SUPPORTED_CONTRACT_TYPES = ['Greater Of', 'Greater Of w/HYN'];

export const canEstimateRoleFilteredPay = (item) =>
    !!item
    && SUPPORTED_CONTRACT_TYPES.includes(item.contractType)
    && !item.isProviderOnTierBonus
    && (item.greater_of_category || 'A').toUpperCase() === 'A';

// Category A only: dailyRatePay × daysWorked (matches doctorPayHelper.calculateDailyRateBasedPayByCategory's default branch).
const dailyRateBasedPayCategoryA = (dailyRatePay, numberOfDaysWorked) =>
    (parseFloat(dailyRatePay) || 0) * (parseFloat(numberOfDaysWorked) || 0);

// Mirrors doctorPayHelper.useGreaterOfContact/useGreaterOfHynContract (Category A path, no tier).
export const estimatePracticePay = (practiceBcare, practicePayOverBase, practiceDailyRatePay, worked) => {
    const billableCareBasedPay = (parseFloat(practiceBcare) || 0) * (parseFloat(practicePayOverBase) || 0) * 0.01;
    if (!worked) {
        return { dailyRateBasedPay: 0, basePay: billableCareBasedPay };
    }
    const dailyRateBasedPay = dailyRateBasedPayCategoryA(practiceDailyRatePay, worked);
    return { dailyRateBasedPay, basePay: Math.max(billableCareBasedPay, dailyRateBasedPay) };
};
